import { render } from "./CardNotification.vue?vue&type=template&id=00560dc8&scoped=true"
import script from "./CardNotification.vue?vue&type=script&lang=js"
export * from "./CardNotification.vue?vue&type=script&lang=js"

import "./CardNotification.vue?vue&type=style&index=0&id=00560dc8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00560dc8"]])

export default __exports__